<template>
	<table class="comparison--estate-agents">
		<thead>
			<tr>
				<th align="left">Agent</th>
				<th align="center">Asking Price</th>
				<th align="center">Avg. Sale Time</th>
				<th align="center">Listed</th>
				<th align="center">Sold</th>
			</tr>
		</thead>
		<tr
			class="estate-agent-comparison__agent"
			v-for="(serviceProvider, serviceProviderIndex) in comparison.serviceProviders" :key="serviceProviderIndex">
			<td v-html="serviceProvider.profile.name"></td>
			<td align="center">
				<span
					v-html="$present('percent', serviceProviderMetric(serviceProvider).averageAskingPrice)"
					class="metrics__metric__stats__value"/>
			</td>
			<td align="center">
				<span class="comparison__results__serviceProvider__details__detail--average-sale-time__weeks">
					<span
						v-html="serviceProviderMetric(serviceProvider).averageSaleDuration.inWeeksAndDays.weeks"
						class="metrics__metric__stats__value"/> <small>weeks</small>
				</span>
				<span class="comparison__results__serviceProvider__details__detail--average-sale-time__days">
					<span
						v-html="serviceProviderMetric(serviceProvider).averageSaleDuration.inWeeksAndDays.days"
						class="metrics__metric__stats__value"/> <small>days</small>
				</span>
			</td>
			<td align="center">
				<span
					v-html="serviceProviderMetric(serviceProvider).numberOfNewListings"
					class="metrics__metric__stats__value"/> <small>in the last 12 months</small>
			</td>
			<td align="center">
				<span
					v-html="$present('percent', serviceProviderMetric(serviceProvider).soldRatio)"
					class="metrics__metric__stats__value"/>
			</td>
		</tr>
	</table>
</template>
<script>
export default {
	props: {
		comparison: {
			type: Object,
			required: true
		}
	},

	methods: {
		labelClass(value, target) {
			return {
				"radio--selected": value === target,
			};
		},
		serviceProviderClass(serviceProvider) {
			return {
				"comparison__results__serviceProvider--offer": serviceProvider.active_offer,
				"comparison__results__serviceProvider--instructed": this.instructed(serviceProvider),
			};
		},
		instructed(serviceProvider) {
			if ("conveyancing" === this.comparison.type) {
				return this.comparison.active_instruction
					&& serviceProvider.pivot.instruction
					&& serviceProvider.pivot.instruction.id === this.comparison.active_instruction.id;
			}

			return serviceProvider.pivot.instruction;
		},
		serviceProviderName(name, index) {
			return name || "Agent " + (index + 1);
		},
		serviceProviderMetric(serviceProvider) {
			return this.bedrooms
				? _.get(serviceProvider.pivot.meta.bedrooms, this.bedrooms)
				: serviceProvider.pivot.meta;
		},
		performanceClass(serviceProvider, metric) {
			return {
				"comparison__results__serviceProvider__details__detail--best": this.serviceProviderIsABestPerformer(serviceProvider, metric)
			};
		},
		serviceProviderIsABestPerformer(serviceProvider, metric) {
			return _.find(this.bestPerformers[metric], function (_serviceProvider) {
				return _serviceProvider.branchId === serviceProvider.pivot.meta.branchId;
			}) ? true : false;
		},
	},
};
</script>
